import React from 'react'
import styled from 'styled-components'

import {
  placeholder,
  borderColor,
  borderError,
  inputBackground,
  inputBackgroundError,
  gray,
} from 'styles/colors'
import { body, title } from 'styles/texts'
import Error from 'components/Error'

export const Input = styled.input`
  ${title};
  background: ${props =>
    props.error ? inputBackgroundError : inputBackground};
  border: 1px solid ${props => (props.error ? borderError : borderColor)};
  border-radius: 4px;
  padding: 8px 13px;
  width: 100%;
  -webkit-appearance: none;

  &::placeholder {
    color: ${placeholder};
  }
`

const Wrapper = styled.div`
  width: 100%;
`

const HelpText = styled.div`
  ${body};
  color: ${gray};
`

export default props => (
  <Wrapper>
    <Input {...props} />
    {props.error ? (
      <Error>{props.error}</Error>
    ) : (
      props.helpText && <HelpText>{props.helpText}</HelpText>
    )}
  </Wrapper>
)



// WEBPACK FOOTER //
// ./src/components/form/Input.js